import { defineComponent as _defineComponent } from 'vue'
import NavItem from "@/components/layout/NavItem.vue"
import useRouter from "@/router/useRouter"

export default /*#__PURE__*/_defineComponent({
  __name: 'AheadBusinessClientNav',
  setup(__props) {

const { routes } = useRouter()

return { __sfc: true,routes, NavItem }
}

})